import { useQuery } from "@tanstack/react-query";
import { ChargeLayerAudit } from "../../models/ChargeLayerAudit";
import { getChargeLayerAudit } from "../../repositories/ChargeRepository";

export const useChargeLayerAuditQuery = (
  chargeId: number | null | undefined,
  refetchInterval: number = 0,
) => {
  return useQuery({
    queryKey: ["charge-layer-audit", chargeId],
    meta: { realtime: ["SCRAP.GetChargeLayerAudit"] },
    queryFn: async ({ signal }) => {
      const resp = await getChargeLayerAudit(chargeId!, signal);
      if (!resp.ok) {
        throw new Error(resp.message || "Failed to load charge layer audit");
      }
      return (resp.data?.tables?.[0]?.rows ?? []) as ChargeLayerAudit[];
    },
    enabled: !!chargeId,
    refetchInterval: refetchInterval > 0 ? refetchInterval * 1000 : false,
  });
};
